import { NotificationPartialStoreState, NOTIFICATION_STATE_KEY, NotificationState } from './notification.reducer';
import { AlertState } from '../notification.models';

// The selector may be invoked with the global store state; be defensive and
// return an empty array when the notification feature slice isn't yet
// registered to avoid runtime "cannot read property 'alerts' of undefined"
// errors. Use `unknown` for the input and narrow to avoid using `any`.
export const getAlerts = (state: unknown): AlertState[] => {
    const root = state as { [key: string]: unknown } | undefined;

    // Try to find the notification feature using the canonical key, or fall
    // back to a common property name used elsewhere.
    const featureCandidate = root?.[NOTIFICATION_STATE_KEY] ?? root?.['notification'];
    if (!featureCandidate) {
        return [];
    }

    const notificationState =
        (featureCandidate as NotificationPartialStoreState)[NOTIFICATION_STATE_KEY] ||
        (featureCandidate as unknown as NotificationState);
    return (notificationState?.alerts as AlertState[]) ?? [];
};
